import { FeatureFlag } from '@ps/web-core-enums';
import { useScreenSize } from '@ps/web-shared-components';
import classnames from 'clsx';
import React, { createRef } from 'react';
import { useSelector } from 'react-redux';
import { Route, useParams } from 'react-router';

import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import { ClubContainer, MIN_DESKTOP_CLIENT_WIDTH, useHomeGamesWidget } from '@swf/poker';

import useInviteToClub from '../Invite/useInviteToClub';

import AnimateClubs from './AnimateClubs/AnimateClubs';
import ClubButtons from './ClubButtons/ClubButtons';
import ClubItem from './ClubItem/ClubItem';
import styles from './MyClubs.scss';
import NoClubs from './NoClubs/NoClubs';

const MyClubs: React.FC = () => {
  const { widgetSelect } = useHomeGamesWidget();
  const { homeGamesClubs: clubsPath = '' } = useSelector(select.cms.getAliases);
  const clubs = useSelector(widgetSelect.clubs);
  const isMobileDevice = useSelector(select.device.isMobile);
  const isSplitClubsSidebarEnabled = useFeature(FeatureFlag.PKRHomeGamesNewSideBar);
  const { clubId, section } = useParams<{ clubId: string; section: string }>();
  const { windowSize } = useScreenSize();
  const hasClubs = !!clubs.length;
  const showClubButtons =
    !(windowSize.width >= MIN_DESKTOP_CLIENT_WIDTH) || !isSplitClubsSidebarEnabled;

  useInviteToClub();

  if (clubId && section) {
    return (
      <Route
        path={clubsPath}
        render={(props) => <ClubContainer {...props} path={clubsPath} loading />}
      />
    );
  }

  return (
    <div className={classnames(styles.container, { [styles.mobileClickFeedback]: isMobileDevice })}>
      {!hasClubs && <NoClubs />}
      {hasClubs && (
        <>
          {showClubButtons && <ClubButtons />}
          <div className={styles.clubsContainer}>
            <AnimateClubs>
              {clubs.map((club) => (
                <ClubItem key={club.clubId} ref={createRef()} {...club} />
              ))}
            </AnimateClubs>
          </div>
        </>
      )}
    </div>
  );
};

export default MyClubs;
